import { tasks } from '@markku/db'
import { createInsertSchema, createSelectSchema } from 'drizzle-zod'
import { z } from 'zod'

export const selectTaskSchema = createSelectSchema(tasks).omit({
  deduplicationKey: true, // Internal field for duplicate prevention
})

export const upsertTaskSchema = createInsertSchema(tasks).omit({
  id: true,
  createdAt: true,
  updatedAt: true,
  createdByUserId: true, // Will be set from context
  completedAt: true, // Will be set automatically when completed changes
  deduplicationKey: true, // Internal field, not settable via API
})

export const selectTaskWithUserSchema = selectTaskSchema.extend({
  assignedUser: z
    .object({
      id: z.number(),
      firstName: z.string(),
      lastName: z.string(),
      email: z.string(),
    })
    .optional(),
  createdBy: z
    .object({
      id: z.number(),
      firstName: z.string(),
      lastName: z.string(),
      email: z.string(),
    })
    .optional(),
  entity: z
    .object({
      id: z.number(),
      name: z.string(),
      type: z.string(),
    })
    .optional(),
})

// Type exports
export type Task = z.infer<typeof selectTaskSchema>
export type TaskWithUser = z.infer<typeof selectTaskWithUserSchema>
export type UpsertTask = z.infer<typeof upsertTaskSchema>
